import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        richColors
        position="top-right"
        toastOptions={{
          className: "!rounded-none !border-2 !border-black !font-body",
        }}
      />
    </div>
  );
}

export default App;
